module.exports = __webpack_public_path__ + "img/investor_polygon@2x.c7cbbade.png";